export enum IdentRouteNames {
  MAIN = 'identificationMain',
  IDIN = 'identificationIdin',
  WORLD = 'identificationWorld',
  BUSINESS = 'identificationBusiness',
}
